import { render, staticRenderFns } from "./psychologyTeacherDialog.vue?vue&type=template&id=2a43423a&"
import script from "./psychologyTeacherDialog.vue?vue&type=script&lang=js&"
export * from "./psychologyTeacherDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports